import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '../../configurations/server-config';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(private http: HttpClient) { }

  countlogs(): any{
    return this.http.get(`${API_URL}/countlogs`);
  }

  updatelog(id: any){
    return this.http.post(`${API_URL}/logupdate?id=${id}`,null);
  }
}
